module.exports = __webpack_public_path__ + "static/media/williamAbbott25.cff31578.png";